import { Ktostamm } from './ktostamm';
import { Vkforg } from './vkforg';
import { Artstamm } from './artstamm';

export interface Kopfau {
  id: number;
  ktostamm: Ktostamm;
  abholdatum: string;
  belegdatum: string;
  hauptartikel: Artstamm;
  extbestellnr?: string;
  objekt: { id: number; };
  istzeit: object;
  kommentar: string | null;
  goldschmiedeText?: string | null;
  preisebene?: {
    preisebene: string;
    bezeichnung: string;
  };
  kundenauftragsvkforg: Vkforg;
  status: 'ABGESCHLOSSEN' | 'GESTARTET' | 'PAUSIERT' | string;
  verkaufsart?: {
    verkaufsart: number;
    bezeichnung: string;
  };
  lieferhinweis?: string;
  kzgarantie?: 'N' | 'J';
  archivekey?: any;
  idkundenauftrag?: number;
  vkpreis: null | number;
  pmstaet: PmsTaetigkeit[] | null;
}

export type PmsTaetigkeit = {
  pmstaet: string;
  bezeichnung: string;
}

export type KopfauMetadata = {
  metadata: { updating: boolean }
}

export type KopfauWithMetadata = { kopfau: Kopfau } & KopfauMetadata
